
// import MTable from 'm-table'
import MTable from 'm-table/package/Table.vue';

export default MTable;